<template>
  <v-app v-if="articleInfoValue">
    <v-container fluid class="article-actions">
      <v-row>
        <v-col cols="2">
          <v-subheader>عنوان</v-subheader>
        </v-col>
        <v-col cols="8">
          <v-text-field placeholder="عنوان" v-model="title"></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2">
          <v-subheader>توضیح کوتاه</v-subheader>
        </v-col>
        <v-col cols="8">
          <v-text-field
            placeholder="توضیح کوتاه"
            v-model="shortDescription"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2">
          <v-subheader>مهم بودن</v-subheader>
        </v-col>
        <v-col cols="8">
          <v-switch v-model="ex11"></v-switch>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2">
          <v-subheader>کلمه کلیدی</v-subheader>
        </v-col>
        <v-col cols="8">
          <template>
            <v-text-field v-model="keyWord" clearable label="کلمه کلیدی">
            </v-text-field>
            <span>کلمات کلیدی را با , از هم جدا کنید</span>
          </template>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2">
          <v-subheader>تگ </v-subheader>
        </v-col>
        <v-col cols="8">
          <template>
            <v-combobox
              v-model="tags"
              chips
              clearable
              label="تگ"
              multiple
              reverse
            >
            </v-combobox>
          </template>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2">
          <v-subheader>دسته بندی </v-subheader>
        </v-col>
        <v-col cols="8">
          <template>
            <v-combobox
              v-model="articleCategoryId"
              :items="articleCategoryList"
              chips
              clearable
              label="دسته بندی"
              reverse
            >
            </v-combobox>
          </template>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-subheader>توضیحات</v-subheader>
        </v-col>
        <v-col cols="8">
          <ckeditor v-model="description" :config="editorConfig"></ckeditor>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2">
          <v-subheader>تصویر</v-subheader>
        </v-col>
        <v-col cols="8">
          <input type="file" @change="onFileSelected" />
          <img :src="image" height="200" alt="" />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2">
          <v-subheader>نویسنده</v-subheader>
        </v-col>
        <v-col cols="8">
          <v-text-field placeholder="نویسنده" v-model="wirter"></v-text-field>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-btn
          class="ml-4 white--text"
          color="indigo darken-2"
          @click="editHandler"
        >
          ثبت کردن
        </v-btn>
        <router-link to="/article-management/article">
          <v-btn class="white--text font-weight-bold indigo lighten-2">
            انصراف
          </v-btn>
        </router-link>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import baseURL from "@/axios";
export default {
  created() {
    axios.get(`${baseURL}ArticleCategory/GetAll`).then((res) => {
      res.data.data.map((item) => {
        this.articleCategoryList.push({
          value: item.id,
          text: item.title,
        });
      });
    });
  },
  data() {
    return {
      ex11: true,
      id: 0,
      title: "",
      editorConfig: {
        versionCheck: false,
      },
      shortDescription: "",
      keyWord: "",
      description: "",
      image: "",
      articleCategoryId: null,
      articleCategoryList: [],
      tags: [],
      wirter: "",
      keyWords: "",
    };
  },
  computed: {
    ...mapGetters(["tokenValue", "articleInfoValue"]),
  },
  methods: {
    onFileSelected(event) {
      this.image = event.target.files[0];
    },
    async editHandler() {
      let tagsStr = "";
      this.tags.map((item) => {
        tagsStr += " " + item;
      });
      await axios
        .post(
          `${baseURL}Article/Add`,
          {
            title: this.title,
            wirter: this.wirter,
            shortDescription: this.shortDescription,
            keyWords: this.keyWord,
            description: this.description,
            isImportant: this.ex11,
            articleCategoryId: this.articleCategoryId.value,
            tags: tagsStr,
          },
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
          }
        )
        .then((res) => {
          // ////////console.log(response);
          const fd = new FormData();
          fd.append("image", this.image);
          axios
            .post(`${baseURL}Article/UploadImage?id=${res.data.data.id}`, fd, {
              headers: {
                Authorization: `Bearer ${sessionStorage.getItem("token")}`,
              },
            })
            .then(() => {
              this.$router.push("/article-management/article");
            });
        });
      // .catch((err) => ////////console.log(err));
    },
  },
};
</script>

<style>
.article-actions {
  background: #ffffff;
  height: auto;
}
.v-input__control {
  direction: ltr;
}
.v-input__slot {
  flex-direction: row-reverse;
}
.v-application--wrap {
  min-height: auto !important;
}
.theme--light.v-input input {
  text-align: right;
}
</style>
